import React, { useState, useEffect, useRef } from 'react';
import ReactDOM from 'react-dom';
import MaterialTable, { MTableToolbar } from 'material-table';
import { withStyles } from '@material-ui/core/styles';
import PropTypes from 'prop-types';
import { Typography, Box, Paper, Grid, Button } from '@material-ui/core';
import * as settingLabelAction from '../../../actions/settingLabel.action';
import { useDispatch, useSelector } from 'react-redux';
// import globalStyles
import globalStyles from '../../../styles/globalStyles';

//import AppSidebarRBack, IssueCard, ActivityCard
import AppSidebarRBack from './../../fragments/AppSidebarRBack';
import IssueCard from './../../fragments/IssueCard';
import ActivityCard from './../../fragments/ActivityCard';
import FormComment from './../../fragments/FormComment';

// import dom Constant
import { dom } from './../../../constants';

// import utils
import { formatDatetime, logger } from './../../../utils/utils';

// import hooks
import { useHandleClientError } from '../../../utils/HttpClient';

// import data
import { issues } from './../../../data';
import EditTwoToneIcon from '@material-ui/icons/EditTwoTone';
import DeleteTwoToneIcon from '@material-ui/icons/DeleteTwoTone';
import { createMuiTheme, ThemeProvider } from '@material-ui/core/styles';
import Toolbar from '@material-ui/core/Toolbar';
import Icon from '@material-ui/core/Icon';
import AddTwoTone from '@material-ui/icons/AddTwoTone';
import SettingLabelManagePage from './SettingLabelManagePage';
import { ConfirmDialog } from '../../fragments/Dialog/Dialog';
import clsx from 'clsx';
import {muiTable} from '../../../constants/index';

// Styles
const styles = (theme) => ({
  ...globalStyles(theme),
  root: {
    margin: theme.spacing(1),
  },
  formControl: {
    margin: theme.spacing(1, 0, 1, 0),
  },
  card: {
    minWidth: 275,
    padding: theme.spacing(1, 1, 2, 2),
  },
  cardContent: {
    minHeight: 275,
  },
  section: {
    margin: theme.spacing(1),
  },
  paper: {
    padding: theme.spacing(1),
    textAlign: 'center',
    color: theme.palette.text.secondary,
  },
  cursor_pointer: {
    cursor: 'pointer',
  }
  
});
const theme = createMuiTheme({
  palette: {
    primary: {
      main: '#4caf50',
    },
    secondary: {
      main: '#ff9100',
    },
  },
});
const SettingLabelPage = React.memo((props) => {
  let { data, classes } = props;
  const dispatch = useDispatch();
  const SettingLabelReducer = useSelector(
    ({ SettingLabelReducer }) => SettingLabelReducer
  );

  const [open, setOpen] = React.useState(false);
  const [actionStatus, setActionStatus] = React.useState(false);
  const [editKey, setEditKey] = React.useState(null);
  const [openConfirm, setOpenConfirm] = React.useState(false);
  const [selectLabelId, setSelectLabelId] = React.useState(null);
  const [messageConfirm, setMessageConfirm] = React.useState('');
  //Reference of material-table
  const tableRef = useRef();

  // let stateGroupSave = groupPermissionReducer.save;

  /*
    dispatch(
     settingPermissionAction.loadSettingPermission({
        per_page: 10,
        page: 1,
      })
    );
*/
  //set innit page options
  const [pageOptions, setPageOptions] = React.useState({
    pageSize: 10,
    pageSizeOptions: [5, 10, 20, 100],
  });

  const loadSettingLabel = (query) => {
    const initData = { data: [], page: 1, totalCount: 0 };
    const { orderBy, orderDirection, page, pageSize, search } = query;
    setPageOptions({
      pageSize: pageSize,
      pageOptions: pageOptions.pageSizeOptions,
    });

    //return dispatch (Promise)
    return dispatch(
      settingLabelAction.loadSettingLabel({
        columnOrder: orderBy ? orderBy.field : orderBy,
        isAscending: orderDirection === 'asc',
        pageNo: page + 1,
        perPage: pageSize,
        search,
      })
    )
      .then((content) => {
        return {
          data: content.data,
          page: page,
          totalCount: content.countRow,
        };
      })
      .catch((error) => {
        // handleClientError(error);
      });
  };

  const deleteSettingLabel = () => {
    dispatch(
      settingLabelAction.deleteSettingLabel(selectLabelId)
    ).then(() => {
      reloadTable();
    });
  };

  useEffect(() => {
    // loadSettingPermission();
  }, []);

  const reloadTable = () => {
    tableRef.current.onQueryChange();
  };
  const handleClickConfirm = (status) => {
    if (status) {
      // action delete
      deleteSettingLabel();
    } else {
    }
    setOpenConfirm(false);
  };

  let settingLabelData =
    SettingLabelReducer.result.content.data.length > 0
      ? SettingLabelReducer.result.content
      : null;

  let labelTitle = 'ป้ายกำกับ';
  let labelAdd = 'เพิ่มป้ายกำกับ';
  return (
    <div className={classes.root}>
       {open ? (
        <SettingLabelManagePage
          open={open}
          setOpen={setOpen}
          actionStatus={actionStatus}
          keyValues={editKey}
          reloadTable={reloadTable}
        />
      ) : null}

      <ConfirmDialog
        open={openConfirm}
        handleClose={(v) => handleClickConfirm(v)}
        message={messageConfirm}
      />
      <Grid container spacing={1}>
        {/* <Grid item xs={12} xl={12}>
          <Paper className={classes.paper}>
            <span>test</span>
          </Paper>
        </Grid> */}
        <Grid item xs={12} xl={12}>
          <MaterialTable
            tableRef={tableRef}
            title={labelTitle}
            columns={[
              {
                title: 'ป้ายกำกับ',
                render: (rowData) => {
                  const padding={padding:5};
                  return (
                    <span
                      style={{...padding,...JSON.parse(rowData.style)}}
                    >
                      {rowData.name}
                    </span>
                  );
                },
              },
              { title: 'คำอธิบาย', field: 'description' },
            ]}
            options={{
              search: true,
              searchAutoFocus: true,
              headerStyle: {
                textAlign: 'center',
                fontWeight:'bold'
              },
              cellStyle: {
                textAlign: 'center',
              },
              ...pageOptions,
            }}
            localization={{
              ...muiTable.localization,
              header: {
                   actions: 'แก้ไข | ลบ'
               }
             }
             }
            data={loadSettingLabel}
            actions={[
              {
                icon: 'edit',
                tooltip: <span style={{fontSize:'0.9rem',padding:'10px'}}>{'แก้ไข'}</span> ,
                onClick: (event, rowData) => {
               
                  setEditKey(rowData.id);
                  setActionStatus({ action: 'edit', label: 'แก้ไข' });
                  setOpen(true);
                },
              },
              (rowData) => ({
                icon: 'delete',
                tooltip: <span style={{fontSize:'0.9rem',padding:'10px'}}>{'ลบ'}</span>,
                onClick: (event, rowData) => {
                  setSelectLabelId(rowData.id);
                  setMessageConfirm(
                    'ท่านต้องการลบป้ายกำกับ "' + rowData.name + '"หรือไม่'
                  );

                  setOpenConfirm(true);
                },
              }),
            ]}
            components={{
              Toolbar: (props) => (
                <div>
                  <MTableToolbar {...props} />
                  <div style={{ padding: '0px 10px' }}>
                    <Button
                      variant="contained"
                      color="primary"
                      //className={classes.button}
                      startIcon={<AddTwoTone />}
                      onClick={(event, rowData) => {
                        setActionStatus({ action: 'add', label: 'เพิ่ม' });
                        setOpen(true);
                      
                      }}
                    >
                      {labelAdd}
                    </Button>
                  </div>
                </div>
              ),
            }}
          />
        </Grid>
      </Grid>
    </div>
  );
});

SettingLabelPage.prototype = {
  data: PropTypes.object,
};

export default withStyles(styles)(SettingLabelPage);
